import {
    CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST,
    CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS,
    CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE,

    CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST,
    CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS,
    CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterFinSurfaces: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE:
                return []
            default:
                return state
        }
    },
    masterFinSurface: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/finSurface.js